import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Typography, Input, Button, Alert, Space, Spin, Card } from 'antd';
import { CopyOutlined, QrcodeOutlined } from '@ant-design/icons';
import { QRCodeCanvas } from 'qrcode.react';

const { Title, Text } = Typography;

const Promouvoir = () => {
  const [lienPartage, setLienPartage] = useState('');
  const [loading, setLoading] = useState(false);
  const [copieSuccess, setCopieSuccess] = useState(false);
  const [showQr, setShowQr] = useState(true);

  const token = localStorage.getItem('token'); 
  const employerRaw = localStorage.getItem('employer');
  const employer = employerRaw ? JSON.parse(employerRaw) : null;
  const influenceurId = employer?.id;

  useEffect(() => {
    if (!influenceurId) return;

    setLoading(true);
    axios.get(`http://localhost:8080/influenceur/api/influenceurs/${influenceurId}/lien-partage`, {
      headers: {
        'Authorization': 'Basic ' + token,
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      setLienPartage(res.data);
    })
    .catch(err => {
      console.error('Erreur récupération lien partage:', err);
      setLienPartage('');
    })
    .finally(() => setLoading(false));
  }, [influenceurId, token]);

  const copierLien = () => {
    if (!lienPartage) return;
    navigator.clipboard.writeText(lienPartage).then(() => {
      setCopieSuccess(true);
      setTimeout(() => setCopieSuccess(false), 2000);
    });
  };

  return (
    <Card
      style={{ maxWidth: 600, margin: '3rem auto', borderRadius: 12, boxShadow: '0 8px 16px rgba(0,0,0,0.1)' }}
      bordered={false}
    >
      <Space direction="vertical" size="large" style={{ width: '100%', textAlign: 'center' }}>
        <Title level={2} style={{ color: '#1890ff' }}>Promouvoir votre lien de partage</Title>
        <Text style={{ color: '#fa8c16', fontSize: 16, fontWeight: 'bold' }}>
          Partagez ce lien pour inviter vos clients facilement !
        </Text>

        {loading && <Spin size="large" tip="Chargement du lien..." />}

        {!loading && lienPartage && (
          <>
            {showQr && (
              <div style={{ marginBottom: 24 }}>
                <QRCodeCanvas 
                  value={lienPartage} 
                  size={180} 
                  bgColor="#ffffff" 
                  fgColor="#1890ff" 
                  level="H"
                  includeMargin={true}
                />
              </div>
            )}

            <Input 
              readOnly 
              value={lienPartage} 
              size="large" 
              style={{ fontWeight: 'bold', color: '#1890ff' }} 
              suffix={
                <Button 
                  type="link" 
                  icon={<CopyOutlined />} 
                  onClick={copierLien} 
                  style={{ fontSize: 16 }}
                />
              }
            />

            {copieSuccess && (
              <Alert
                message="Lien copié dans le presse-papier !"
                type="success"
                showIcon
                style={{ marginTop: 16 }}
              />
            )}

            <Button
              type="default"
              icon={<QrcodeOutlined />}
              onClick={() => setShowQr(!showQr)}
              style={{ marginTop: 20 }}
            >
              {showQr ? 'Masquer QR Code' : 'Afficher QR Code'}
            </Button>
          </>
        )}

        {!loading && !lienPartage && (
          <Alert 
            message="Impossible de récupérer le lien. Veuillez réessayer plus tard." 
            type="error" 
            showIcon 
          />
        )}
      </Space>
    </Card>
  );
};

export default Promouvoir;
